import { render } from "./Mills.vue?vue&type=template&id=c6498e68&scoped=true"
import script from "./Mills.vue?vue&type=script&lang=js"
export * from "./Mills.vue?vue&type=script&lang=js"

import "./Mills.vue?vue&type=style&index=0&id=c6498e68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6498e68"]])

export default __exports__